/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
 */

var Lajax = (function () {
    'use strict';

    var baseObjectString = 'l-ajax-js', // Used for data attrs and classes
        inlineLoaderClass = 'button--loader', // Used with the button block styles for inline loader
        inlineLoadingClass = 'button--loading',
        ajaxInProgress = false; // Indicates if a call is in progress

    // ----------------------
    // Private methods
    // ----------------------

    var _resetApp = function() {
        // Reset ajax state
        ajaxInProgress = false;

        // for other modules
        pubsubEvent.emit('pubsubEvent_ajaxComplete');

        // Re-bind trigger click (and recreate loaders if needed)
        init();
    };

    var _updateView = function($trigger, dataObj) {
        // Check there is content returned
        if (dataObj.content !== undefined) {
            var scrollToElementId = dataObj.scrollto,
                contentMappings = dataObj.content;

            // Iterate over the new content
            $.each(contentMappings, function (mapType, mapData) {
                // allow only specified types of mapping
                if (['replace', 'append', 'update'].indexOf(mapType) > -1) {
                    $.each(mapData, function (selector, htmlData) {
                        var $el = $(selector);

                        if ($el.length) {
                            if (mapType === 'replace') {
                                // Replace whole element
                                $el.replaceWith(htmlData);
                            } else if (mapType === 'append') {
                                // Append the content
                                $el.append(htmlData);
                            } else if (mapType === 'update') {
                                // Update the content

                                // content might be wrapped with the spinner wrapper
                                var $spinnerEl = $el.find('.' + baseObjectString + '-inner');

                                if ($spinnerEl.length) {
                                    $spinnerEl.siblings().remove();
                                    $spinnerEl.parent().append(htmlData);
                                } else {
                                    // Append the content
                                    $el.html(htmlData);
                                }
                            }
                        }
                    });
                }
            });

            // Scroll to the element
            var scrolltoTarget = $(scrollToElementId);

            if (scrolltoTarget !== undefined && scrolltoTarget.length && scrolltoTarget.offset()) {
                scrolltoTarget = scrolltoTarget.length ? scrolltoTarget : $('[name=' + this.hash.slice(1) + ']');
                $('html, body').animate({
                    scrollTop: scrolltoTarget.offset().top
                }, 500);
            }

            // Update numresults on process pages
            _updateProcessNumresults();
        } else {
            // Backend error
            $trigger.after('<p>There seems to be a problem with this action. Please try again later.</p>');
        }

        // Remove the loader
        _setLoadingState($trigger, false);

        // Reset
        _resetApp();

        // Log the data
        // console.log(dataObj)
    };

    var _setLoadingState = function($trigger, state) {
        // Get all the items requiring a loader
        var loaderItems = $trigger.data(baseObjectString + '-loader').split(',').map(JSON.parse);

        $.each(loaderItems, function(index, el) {
            // Add the loader
            if (state === true) {
                window.requestAnimationFrame(function() {
                    // Conditional to see if its a button or not
                    if ($(el).is('button, input, a')) {
                        $(el).addClass(inlineLoadingClass);
                    } else {
                        $(el).find('.' + baseObjectString + '-inner').off('transitionend.ajaxout');
                        $(el).find('.' + baseObjectString + '-inner').addClass(baseObjectString + '-inner--in');
                    }

                    // Get the ajaxed data
                    _getAjaxData($trigger);
                });
            } else if (state === false) {
                // remove the loader (if still present)
                window.requestAnimationFrame(function () {
                    if ($(el).length) {
                        if ($(el).is('button, input, a')) {
                            $(el).removeClass(inlineLoadingClass);

                            // Reset
                            _resetApp();
                        } else {
                            $(el).find('.' + baseObjectString + '-inner').addClass(baseObjectString + '-inner--out');

                            $(el).find('.' + baseObjectString + '-inner').off('transitionend.ajaxout').on('transitionend.ajaxout', function (event) {
                                $(el).find('.' + baseObjectString + '-inner').removeClass(baseObjectString + '-inner--in');
                                $(el).find('.' + baseObjectString + '-inner').removeClass(baseObjectString + '-inner--out');

                                // Reset
                                _resetApp();
                            });
                        }
                    }
                });
            }
        });
    };

    var _setPreLoadingState = function($trigger) {
        // Get all the items requiring a loader
        var loaderItems = $trigger.data(baseObjectString + '-loader').split(',').map(JSON.parse);

        // Set to loadable content
        $.each(loaderItems, function(index, el) {
            if ($(el).is('button, input, a')) {
                if (!$(el).hasClass(inlineLoaderClass)) {
                    $(el).addClass(inlineLoaderClass);
                }
            } else {
                if ($(el).find('.' + baseObjectString).length === 0) {
                    $(el).wrapInner('<div class="' + baseObjectString + '"></div>');
                    $(el).find('.' + baseObjectString).prepend('<div class="' + baseObjectString + '-inner"></div>');
                }
            }
        });
    };

    var _getAjaxData = function($trigger) {
        var actionURL,
            submitData;

        if ($trigger.is('[type="submit"]')) {
            var $form = $trigger.parents('form');
            // Form action and data
            actionURL = $form.attr('action');
            submitData = $form.serialize();
        } else {
            // For a regular link or button ust use the href
            actionURL = $trigger.attr('href');
            submitData = '';
        }

        // Timed out so no jumpy changes
        setTimeout(function() {
            $.ajax({
                url: actionURL,
                type: 'GET',
                dataType: 'json',
                data: submitData,
                encode: true,
                cache: false
            })
            .done(function(resultObj) {
                var stateURL = actionURL + (submitData ? ('?' + submitData) : ''),
                    stateObj = {
                        stateURL: stateURL
                    },
                    ga = window[window.GoogleAnalyticsObject || 'ga'];

                window.history.pushState(stateObj, '', stateURL);

                if (typeof ga === 'function') {
                     ga('send', 'pageview', stateURL);
                }

                // Update the content

                _updateView($trigger, resultObj);
            })
            .fail(function(e) {
                $trigger.after('<p>There seems to be a problem triggering this action. Please try again later.</p>');
            });
        }, 500);
    };

    // Handle using the back button
    var _popState = function() {
        window.addEventListener('popstate', function(e) {
            // Make sure Safari (ios8) popstate isnt triggered when the page is loaded
            var popStatus = Cookies.get('prevPopped');

            // Has the cookie been set
            if (popStatus !== null) {
                // Is it not the same as the current page
                if (popStatus !== window.location.href) {
                    Cookies.set('prevPopped', window.location.href);
                    location.reload();
                }
            }
        });
    };

    var _bindTriggerClick = function() {
        var $triggers = $('[data-' + baseObjectString + '-trigger]');

        // if a trigger exists
        if ($triggers.length) {
            $triggers.each(function(index, el) {
                var thisTrigger = $(this);

                thisTrigger.off('click.ajax').on('click.ajax', function(e) {
                    e.preventDefault();
                    // Prevent multiple requests
                    if (ajaxInProgress === false) {
                        // Set in progress
                        ajaxInProgress = true;

                        _setLoadingState(thisTrigger, true);
                    }
                });
            });
        }
    };

    var _updateProcessNumresults = function() {
        if ($('.processlist').length > 0) {
            $('.js-listing-numshowing').html(($('.processlist-item').length));
        }
    };

    // ----------------------
    // Public methods
    // ----------------------

    var init = function() {
        var $triggers = $('[data-' + baseObjectString + '-trigger]');

        // if a trigger exists
        if ($triggers.length) {
            $triggers.each(function(index, el) {
                var thisTrigger = $(this);

                // Add class to prepare for loaders
                _setPreLoadingState(thisTrigger);
            });

            _bindTriggerClick();
            // Setup popstate for history API
            _popState();
        }
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Lajax.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

var Cannouncement = (function () {
    'use strict';

    // Component vars
    var componentClass = 'announcement',
        cookieHideValue = 'hide';

    var _bindEvents = function($announcement, $closeBtn) {
        $closeBtn.on('click', function(event) {
            event.preventDefault();

            $announcement.css({
                opacity: 0
            });

            $announcement.off('transitionend.announce').on('transitionend.announce',
                function(event) {
                    // Do something when the transition ends
                    $announcement.attr('aria-hidden', true);
                    $announcement.css({
                        height: 0
                    });
                    $announcement.off('transitionend.announceRemove').on('transitionend.announceRemove',
                        function(event) {
                            $announcement.hide();

                            // Store the fact this has been closed
                            Cookies.set($closeBtn.attr('id'), cookieHideValue,
                                {expires: $announcement.data('dismiss-expiry-time')});
                    });
                });
        });

        // So Behaves like a button
        $closeBtn.on('keypress', function(e) {
            if (e.which === 32) {
                $(this).trigger('click');
                e.preventDefault();
            }
        });
    };

    var _setAccessAttrs = function($announcement, $closeBtn) {
        // Needs this role as is not an anchor with js
        $closeBtn.attr('role', 'button');

        var $announcementHeight;

        // Use on load as otherwise safari doesn't measure correctly
        $(window).on('load', function() {
            $announcementHeight = $announcement.outerHeight(true);

            // anim
            $announcement.css({
                opacity: 1,
                height: $announcementHeight,
                transition: 'opacity .2s ease, height .2s ease'
            });
        });
        // aria
        $announcement.attr({
            'id': componentClass,
            'aria-hidden': false
        });
    };

    // Public method
    var init = function() {
        var $announcement = $('.' + componentClass);

        if ($announcement.length) {
            var $closeBtn = $announcement.find('.' + componentClass + '__close');

            if ($closeBtn.length) {
                _setAccessAttrs($announcement, $closeBtn);
                _bindEvents($announcement, $closeBtn);
            }
        }
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Cannouncement.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary Enhancement to the jquery-accessible-tabs.js library to facilitate select style presentation on mobile
 * Adds additional state classes to allow for styling like a select
 *
*/

// Create namespace for module
var Btabs = (function () {
    'use strict';

    // Validation method
    // Check all elements that shouls be are th
    // var _spanValidation = function(tableInnards) {

    // }

    // Validation method
    // if non default table and rowspan/colspan used check not been applied to first header element
    var _BindUIEvents = function($tabpanel) {
        var $list = $tabpanel.find('.b-js-tabs__list'),
            $item = $tabpanel.find('.b-js-tabs__item'),
            $link = $tabpanel.find('.b-js-tabs__link');

         $item.on('click', function(event) {
            $('body').keydown(function () {
                $list.addClass('b-js-tabs__list--active');
            });

            $list.toggleClass('b-js-tabs__list--active');
            console.log('click fired');
        });

        $('html').on('click', function(event) {
            if (!$(event.target).hasClass('b-js-tabs__link')) {
                $list.removeClass('b-js-tabs__list--active');
            }
        });

        $link.on('focus', function(event) {
            $(this).parent().siblings().removeClass('b-js-tabs__item--active');
            $(this).parent().addClass('b-js-tabs__item--active');
            /* Act on the event */
        });
    };

    // add escape key to remove b-js-tabs__list--active
    // add toggle b-js-tabs__list--active when focussed and click enter

    // Public method
    var init = function() {
        $('.b-js-tabs').each(function(index, el) {
            _BindUIEvents($(this));
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Btabs.init();
});

/**
 * @requires jquery.js
 * @requires back-to-top.scss
 *
 * @summary Animated scroll to top of the page
 *
 */

var BbackToTop = (function () {
    'use strict';

    var settings = {
        fromTop: 400,
        delay: 200
    };

    var _bindUIActions = function () {
        var $backToTop = $('.back-to-top');

        // Show / hide anchor after scrolling stopped
        $(window).scroll(function () {
            clearTimeout($.data(this, 'scrollTimer'));

            $.data(this, 'scrollTimer', setTimeout(function () {
                if ($(window).scrollTop() > settings.fromTop) {
                    $backToTop.addClass('back-to-top--show');
                } else {
                    $backToTop.removeClass('back-to-top--show');
                }
            }, settings.delay));
        });

        // Make 'back to top' link go... well, back to top.
        // This should have been handled by the `href="#top"` in `.back-to-top__link`
        // but has been compromised by `rewrite_hash_links: false` in `config.yml`
        $('.back-to-top__link').on('click', function() {
            $('html, body').animate({ scrollTop: 0 }, 420);
            return false;
        });
    };

    var init = function() {
        _bindUIActions();
    };

    return {
        init: init
    };
})();

$(document).ready(function() {
    BbackToTop.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var Bhideshow = (function () {
    'use strict';

    // Stores the content set by data attrs
    var baseClassString = 'b-hide-show-js',
        togglerActiveClass = baseClassString + '__trigger--isactive',
        togglerContent,
        togglerAltContent;

    var _setInactiveAttrs = function($toggler, $block) {
        $block.attr('aria-hidden', true).hide();
        $toggler
            .html(togglerContent)
            .removeClass(togglerActiveClass)
            .attr('aria-expanded', false);
    };

    var _setActiveAttrs = function($toggler, $block) {
        $block.attr('aria-hidden', false).show();
        $toggler
            .html(togglerAltContent)
            .addClass(togglerActiveClass)
            .attr('aria-expanded', true);
    };

    var _bindEvents = function($toggler, $block) {
        $toggler.off('click').on('click', function() {
            if ($block.attr('aria-hidden') === 'true') {
                _setActiveAttrs($toggler, $block);
            } else {
                _setInactiveAttrs($toggler, $block);
            }
        });
    };

    var _setInitialAttrs = function($toggler, $block, index) {
        var blockId = 'b-hide-show-js' + index;
        togglerContent = $toggler.data(baseClassString + '-content');
        togglerAltContent = $toggler.data(baseClassString + '-alt-content');

        $block.attr('id', blockId);

        $toggler.attr({
            'aria-owns': blockId,
            'aria-haspopup': true,
            'aria-expanded': false
        });

        // Check to see if it has the open data attr
        if ($block.data('b-hide-show-js-open') === true) {
            _setActiveAttrs($toggler, $block);
        } else {
            _setInactiveAttrs($toggler, $block);
        }
    };

    var _findElements = function ($wrappers) {
        $wrappers.each(function(index, el) {
            var $wrapper = $(this),
                $toggler = $wrapper.find('.' + baseClassString + '__trigger'),
                $block = $wrapper.find('.' + baseClassString + '__block');

                $block.show();

            // Important:
            // This is used as the CSS hook to determine if the breakpoint requires use of the hide/show
            if ($toggler.css('display') === 'block') {
                _setInitialAttrs($toggler, $block, index);
                _bindEvents($toggler, $block);
            }
        });
    };

    // Exposed function
    var init = function() {
        var $wrappers = $('.' + baseClassString);

        if ($wrappers.length > 0) {
            // Initialise
            _findElements($wrappers);

            // used for ios where a scroll can trigger resize
            var cachedWidth = $(window).width();

            // Re initialise on resize
            var resizeTimer;
            $(window).on('resize', function(e) {
                var newWidth = $(window).width();

                // Check to see if width has actually changed (ios specific)
                if (newWidth !== cachedWidth) {
                    clearTimeout(resizeTimer);

                    resizeTimer = setTimeout(function() {
                            _findElements($wrappers);
                    }, 250);
                }
            });
        }
    };

    // ----------------------
    // Observe events
    // ----------------------

    pubsubEvent.on('pubsubEvent_ajaxComplete', init);

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Bhideshow.init();
});


/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var Bmodaal = (function () {
    'use strict';

    // Public method
    var init = function() {
        var inline = $('[data-modaltrigger]');
        $('.modaal-ajax-js').modaal({
            type: 'ajax'
        });
        $('.modaal-image-js').modaal({
            type: 'image'
        });
        $('.modaal-video-js').modaal({
            type: 'video'
        });

        inline.modaal({
            type: 'inline'
        });

        $('[data-closemodal]').on('click', function() {
            inline.modaal('close');
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Bmodaal.init();
});


var mvtr = (function () {
    'use strict';

    var _getAjaxData = function($trigger) {
        var base = $('[data-mvtr-data-url]'),
            target = $('[data-mvtr-target]'),
            url = base.attr('data-mvtr-data-url'),
            spinner = base.find('[data-mvtr-loading]');

        // Timed out so no jumpy changes
        setTimeout(function() {
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                encode: true,
                cache: false
            })
            .done(function(resultObj) {
                spinner.slideUp(200);

                if (typeof resultObj.html === typeof undefined) {
                    return;
                }

                target
                    .hide()
                    .html(resultObj.html)
                    .slideDown(300);

                // update meta & og content
                if (typeof resultObj.title !== typeof undefined) {
                    var title = 'MVTR | ' + resultObj.title;
                    document.title = title;
                    $('meta[property="og:title"]').attr('content', title);
                    $('meta[property="twitter:title"]').attr('content', title);
                }

                if (typeof resultObj.link !== typeof undefined) {
                    $('meta[property="og:url"]').attr('content', resultObj.link);
                }
            })
            .fail(function(e) {
                target
                    .html('<p>There seems to be a problem with this action. Please try again later.</p>')
                    .slideDown(300);
            });
        }, 500);
    };

    var init = function() {
        _getAjaxData();
    };

    return {
        init: init
    };
})();

$(document).ready(function() {
    mvtr.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var BnavDesktop = (function () {
    'use strict';

    var navExpanded = false,
        baseObjectString = 'navdesktop-js',
        activeTriggerClass = baseObjectString + '__reveal--in',
        transitionInProgress = false;

    // ----------------------
    // Private methods
    // ----------------------

    var _fadeIn = function($mega, $trigger) {
        window.requestAnimationFrame(function() {
            // Animate in
            $trigger.addClass(activeTriggerClass)
                .attr({
                    'aria-expanded': true
                });

            $mega.addClass(baseObjectString + '__mega--in')
                .attr({
                    'aria-hidden': false
                });

            $mega.off('transitionend.megaIn').on('transitionend.megaIn', function(event) {
                // Set state
                transitionInProgress = false;
                navExpanded = true;

                $mega.off();
            });
        });
    };

    var _fadeOut = function($mega, $trigger) {
        window.requestAnimationFrame(function() {
            // Animate out
            $mega.addClass(baseObjectString + '__mega--out');
            $trigger.removeClass(activeTriggerClass)
                .attr({
                    'aria-expanded': false
                });

            $mega.off('transitionend.megaOut').on('transitionend.megaOut', function(event) {
                // Set mega state
                $mega.removeClass(baseObjectString + '__mega--out')
                    .removeClass(baseObjectString + '__mega--in')
                    .attr({
                        'aria-hidden': true
                    });

                // Set global state
                transitionInProgress = false;
                navExpanded = false;
                $mega.off();
            });
        });
    };

    var _replace = function($megasOut, $megaIn, $triggersOut, $triggerIn) {
        $triggerIn.attr({
            'aria-expanded': false
        });

        $megasOut.removeClass(baseObjectString + '__mega--out')
                .removeClass(baseObjectString + '__mega--in');

        window.requestAnimationFrame(function() {
            $triggerIn.attr({
                'aria-expanded': false
            });

            $megaIn.addClass(baseObjectString + '__mega--in')
                .attr({
                    'aria-hidden': true
                });

            $triggersOut.removeClass(activeTriggerClass);

            $triggerIn.addClass(activeTriggerClass);

            $triggerIn.off('transitionend.triggerIn').on('transitionend.triggerIn', function(event) {
                // Set global state
                transitionInProgress = false;
                navExpanded = true;
                $triggerIn.off('transitionend.triggerIn');
            });
        });
    };

    // Determine the action based on what was clicked and the current state
    var _toggleState = function($thisTrigger, $thisMega, $triggers, $megas) {
        // Determine if any mega is already open
        var megaActive = false;
        $megas.each(function(index, el) {
            if ($(this).is('.' + baseObjectString + '__mega--in')) {
                megaActive = true;
            }
        });

        // Nothing is currently open
        if ($thisTrigger.not('.' + activeTriggerClass) && megaActive === false) {
            _fadeIn($thisMega, $thisTrigger);
        }

        // Mega is open, but clicked on another trigger
        if ($thisTrigger.not('.' + activeTriggerClass) && megaActive === true) {
            var $megasOut = $('.' + baseObjectString + '__mega').not($thisMega);

            var $triggersOut = $('.' + baseObjectString + '__reveal').not($thisTrigger);

            _replace($megasOut, $thisMega, $triggersOut, $thisTrigger);
        }

        // Close by clicking the open item's Parent
        if ($thisTrigger.is('.' + activeTriggerClass)) {
            // fade out mega
            _fadeOut($thisMega, $thisTrigger);
        }
    };

    // Setup Accessibility signposting
    var _setAccessAttrs = function($mega, $trigger, index) {
        var megaId = baseObjectString + index;

        $trigger.next('.' + baseObjectString + '__mega').attr('id', megaId);

        $trigger.attr({
                'aria-owns': megaId,
                'aria-haspopup': true,
                'aria-expanded': false
            })
            .addClass(baseObjectString + '__reveal--is-parent');

        $mega.attr({
            'aria-hidden': true
        });
    };

    // ----------------------
    //  Public methods
    // -----------------------

    var init = function() {
        var $triggers = $('.' + baseObjectString + '__reveal'),
            $megas = $('.' + baseObjectString + '__mega');

        // Bind UI actions
        $triggers.each(function(index, el) {
            var $trigger = $(this);

            // Check the trigger has a drop down
            if ($trigger.next('.' + baseObjectString + '__mega').length) {
                var $AccessMega = $trigger.next('.' + baseObjectString + '__mega');
                // Set aria
                _setAccessAttrs($AccessMega, $trigger, index);

                $trigger.on('click', function(e) {
                    var $clickedTrigger = $(this),
                        $thisMega = $clickedTrigger.next('.' + baseObjectString + '__mega');

                    e.preventDefault();

                    if (transitionInProgress === false) {
                        transitionInProgress = true;

                        e.stopPropagation();
                        _toggleState($clickedTrigger, $thisMega, $triggers, $megas);
                    }
                });

                // Bind spacebar to anchor
                $trigger.on('keypress', function(e) {
                    if (e.which === 32) {
                        $(this).trigger('click');
                        e.preventDefault();
                    }
                });
            }
        });

        // Click away
        $('body').off('click.megaBody').on('click.megaBody', function(event) {
            if (transitionInProgress === false && navExpanded === true) {
                if (
                    !$(event.target).parents('.' + baseObjectString + '__mega').length &&
                    !$(event.target).is('.' + baseObjectString + '__mega') &&
                    $('.' + activeTriggerClass).length
                ) {
                    $('.' + activeTriggerClass).trigger('click');
                }
            }
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    BnavDesktop.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var BnavMobile = (function () {
    'use strict';

    var _setAccessAttrs = function($navWrapper, $navTrigger) {
        $navTrigger.attr({
            'aria-owns': 'navmobile',
            'role': 'button',
            'aria-haspopup': true
        });

        $navWrapper.attr({
            'aria-hidden': true,
            'id': 'navmobile'
        });
    };

    var _toggleAttrs = function(navWrapper, navTrigger) {
        var body = $('body');
        $('html, body').scrollTop(0);

        navTrigger.toggleClass('navmobile-trigger--isactive');

        if (navWrapper.attr('aria-hidden') === 'true') {
            navWrapper.attr('aria-hidden', false);
            navTrigger.html('<span class="sr-only">Close the mobile menu</span>');
            navWrapper.show();
            body.addClass('overlay--active');

            return;
        }

        navWrapper.attr('aria-hidden', true);
        navWrapper.hide('fast', function() {
            navTrigger.html('<span class="sr-only">Reveal the mobile </span><span class="navmobile-text">Menu</span>');
        });
        body.removeClass('overlay--active');
    };

    var _closenav = function() {
        var navWrapper = $('.navmobile-listwrapper'),
            navTrigger = $('.navmobile-trigger');

        navTrigger.removeClass('navmobile-trigger--isactive');
        navWrapper.attr('aria-hidden', true);
        navTrigger.html('<span class="sr-only">Reveal the mobile </span>Menu');
        navWrapper.hide();
    };

    // Public method
    var init = function() {
        var navWrapper = $('.navmobile-listwrapper'),
            navTrigger = $('.navmobile-trigger');

        _setAccessAttrs(navWrapper, navTrigger);

        navTrigger.on('click', function(e) {
            e.preventDefault();
            _toggleAttrs(navWrapper, navTrigger);

            // Emit event so other modals will close
            pubsubEvent.emit('pubsubEvent_mobileNavClicked');
        });

        // Bind spacebar to anchor
        navTrigger.on('keypress', function(e) {
            if (e.which === 32) {
                $(this).trigger('click');
                e.preventDefault();
            }
        });
    };

    // ----------------------
    // Observe events
    // ----------------------

    pubsubEvent.on('pubsubEvent_siteSearchClicked', _closenav);

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    BnavMobile.init();
});

$(document).ready(function() {
    'use strict';

    var didScroll = false,
        lastScrollTop = 0,
        delta = 5;

    function init() {
        attachEvents();

        setInterval(function() {
            if (didScroll) {
                handleScroll();
                didScroll = false;
            }
        }, 500);
    }

    function attachEvents() {
        $(window).on('scroll', function() {
            didScroll = true;
        });
    }

    /**
     * On scrolling down we want to hide the secondary nav.
     * On scroll up we want to show it again
     */
    function handleScroll() {
        var scroll = $(window).scrollTop(),
            target = $('[data-navslide-scroll]'),
            newDelta = Math.abs(lastScrollTop - scroll);

        if (newDelta <= delta) {
            return;
        }

        // Scroll Down
        if (scroll > lastScrollTop) {
            target.removeClass('navslide-button--above');
        } else {
            target.addClass('navslide-button--above');
        }

        lastScrollTop = scroll;
    }

    init();
});


/**
 * Trigger search when a filter select is changed
 */
var FsiteSearch = (function () {
    'use strict';

    var init = function() {
        var $filter = $('select.search-filter-select');

        $filter.on('change', function(e) {
            $filter.parents('form').find('[data-l-ajax-js-trigger]').click();
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    FsiteSearch.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

 // DISABLE SELECT2 DUE TO ACCESSIBILITY ISSUES

// Create namespace for module
// var Bselect2 = (function () {
//     'use strict';

//     // Array representation of the options currently selected
//     var selectStore = [],
//         // Array representation of the parents currently in a selected state
//         parentsSelected = [],
//         parentDataAttr = 'select2-id',
//         childDataAttr = 'select2-parent-id',
//         parentSelectedClass = 'b-select2-multi__option-parent--selected';

//     var _bindUnSelectEvent = function($selectWrapper) {
//        $selectWrapper.on('select2:unselect', function(evt) {
//             var $select = $(this),
//                 $selectChildren = $select.children();

//             JSON.stringify(evt.params, function (key, value) {
//                 var parentId = value.data.element.getAttribute('data-' + parentDataAttr),
//                     childId = value.data.element.getAttribute('data-' + childDataAttr);

//                 // When you click on a parent element Need to update the children and store results
//                 if (parentId !== null) {
//                     $selectChildren.each(function(index, el) {
//                         if ($(this).data(childDataAttr) === parentId || $(this).data(parentDataAttr) === parentId) {
//                             // Rmove the parent and children
//                             selectStore.splice($.inArray($(this).val(), selectStore), 1);
//                         }
//                     });
//                     // Remove all
//                     $selectWrapper.val('').trigger('change');

//                     // Add back with new Array
//                     $selectWrapper.val(selectStore).trigger('change');
//                 } else if (childId !== null) { // When you click on a selected child of a parent need to always deactivate the parent and remove from store
//                     var parentElem = $select.find('[data-select2-id="' + childId + '"]');
//                     var parentCurrentValue = parentElem.val();

//                     parentElem.removeClass(parentSelectedClass);
//                     parentsSelected.splice($.inArray(parentCurrentValue, parentsSelected), 1);
//                 } else {
//                     // Otherwise you remove the value from the store
//                     var removeValue = value.data.element.getAttribute('value');
//                     selectStore.splice($.inArray(removeValue, selectStore), 1);
//                 }

//                 // Logging
//                 // console.log('Store State:::   ' + selectStore);
//                 // console.log('Parents Selected State:::   ' + parentsSelected);
//             });
//         });
//     };

//     var _bindSelectEvent = function($selectWrapper) {
//         $selectWrapper.on('select2:select', function(evt) {
//             var $select = $(this),
//                 $selectChildren = $select.children();

//             JSON.stringify(evt.params, function (key, value) {
//                 // Used to get parent and child
//                 var parentId = value.data.element.getAttribute('data-' + parentDataAttr);

//                 // Check to see if you clicked on a parent
//                 if (parentId !== null) {
//                     // Get the value of the parent
//                     var parentCurrentValue = value.data.element.getAttribute('value');

//                     // If this is currently selected, then remove all the children from the store
//                     if ($.inArray(parentCurrentValue, parentsSelected) > -1) {
//                         $selectChildren.each(function(index, el) {
//                             var addValue = $(this).val();

//                             if ($(this).data(childDataAttr) === parentId) {
//                                 if ($.inArray(addValue, selectStore) > -1) {
//                                     selectStore.splice($.inArray($(this).val(), selectStore), 1);
//                                 }
//                             }
//                             // Remove selected class
//                             if ($(this).data(parentDataAttr) === parentId) {
//                                 $(this).removeClass(parentSelectedClass);
//                             }
//                         });

//                         // Remove the item from the parentsSelected array
//                         parentsSelected.splice($.inArray(parentCurrentValue, parentsSelected), 1);
//                     } else {
//                         // Otherwise Add all the children to the store
//                         $selectChildren.each(function(index, el) {
//                             // Get the value and see if its already in store
//                             var addValue = $(this).val();

//                             if ($(this).data(childDataAttr) === parentId) {
//                                 if ($.inArray(addValue, selectStore) < 0) {
//                                     // add to store if not already in store
//                                     selectStore.push($(this).val());
//                                 }
//                             }
//                             // Add selected class
//                             if ($(this).data(parentDataAttr) === parentId) {
//                                 $(this).addClass(parentSelectedClass);
//                             }
//                         });

//                         // Store the parent
//                         parentsSelected.push(parentCurrentValue);
//                     }

//                     // trigger the change according to whats now in the store
//                     $selectWrapper.val(selectStore).trigger('change');
//                 } else {
//                     // If this isn't a parent item then just add this to the store for later if its not already in
//                     // No need to trigger change as happens automatically
//                     var addValue = value.data.element.getAttribute('value');

//                     if ($.inArray(addValue, selectStore) < 0) {
//                         // add to store if not already there
//                         selectStore.push(addValue);
//                     }
//                 }

//                 // Logging
//                 // console.log('Store State:::   ' + selectStore);
//                 // console.log('Parents Selected State:::   ' + parentsSelected);
//             });
//         });
//     };

//     var _setupMultiNested = function() {
//         // Setup
//         var $select2MultiNested = $('.field-wrapper .b-select2-multi').select2({
//             // closeOnSelect: false,
//             templateResult: function (data) {
//                 if (!data.element) {
//                   return data.text;
//                 }

//                 var $element = $(data.element);
//                 var $wrapper = $('<span class="b-select2__option"></span>');

//                 $wrapper.addClass($element[0].className);
//                 $wrapper.text(data.text);
//                 return $wrapper;
//             }
//         });

//         // bind events For nested behaviour
//         _bindSelectEvent($select2MultiNested);
//         _bindUnSelectEvent($select2MultiNested);
//     };

//     // Exposed function
//     var init = function() {
//         // init all selects
//         $('select').select2().select2({
//             // closeOnSelect: false,
//             templateResult: function (data) {
//                 if (!data.element) {
//                   return data.text;
//                 }

//                 var $element = $(data.element);
//                 var $wrapper = $('<span class="b-select2__option"></span>');

//                 $wrapper.addClass($element[0].className);
//                 $wrapper.text(data.text);
//                 return $wrapper;
//             }
//         });

//         // Set up more complex multi select with custom events
//         _setupMultiNested();

//         var $labelledSelects = $('select[aria-labelledby]');

//         $labelledSelects.each(function(index, el) {
//             var $select = $(this),
//                 label = $select.attr('aria-labelledby');

//             $select.next('.select2').find('.select2-search__field').attr('aria-labelledby', label);
//         });
//     };

//     // Expose objects here
//     return {
//         init: init
//     };
// })();

// $(document).ready(function() {
//     Bselect2.init();
// });

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary Updates in pge anchor links to scroll to location on page using 'animate'
 *
*/

var BsmoothScroll = (function () {
    'use strict';

    var _bindUIActions = function () {
        $('a[href*="#"]:not([href="#"])').click(function(e) {
            if (
                $(this).is('.navdesktop-js__reveal--is-parent') ||
                $(this).is('.navmobile-trigger')
            ) {
                return;
            }

            /**
            * Do smooth scroll only when we link to an anchor on the same page
            * Note: if using the "Anchor on this page" function in tinymce
            * we cannot compare the location.pathname is there would be none (ie: link is <a href="#anchor-target"></a>)
            */
            var destinationPath = this.pathname.replace(/^\//, '');

            if (destinationPath === '' || (location.pathname.replace(/^\//, '') === destinationPath && location.hostname === this.hostname)) {
                e.preventDefault();
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                scrollToTarget(target);
                return;
            }

            return;
        });
    };

    var init = function () {
        _bindUIActions();
    };

    function scrollToTarget (target) {
        if (target.length) {
            target.attr('tabindex', -1);
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 500, function() {
                target.focus();
            });
            return false;
        }
    }

    return {
        init: init
    };
})();

$(document).ready(function() {
    BsmoothScroll.init();
});

/**
 * Init and extras for youtube videos
 */
$(document).ready(function() {
    'use strict';

    function init() {
        setup($(document));
    }

    function setup(scope) {
        var i = 0;
        const stickyEl = scope.find('[data-sticky]');

        if (stickyEl.length > 0) {
           for (i = 0; i < stickyEl.length; i++) {
               attachSticky(stickyEl[i]);
           }
        }
    }

    function attachSticky(stickyElm) {
        if (!('IntersectionObserver' in window) &&
            !('IntersectionObserverEntry' in window) &&
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
           return; // old browsers just have to cope with things being uglier
        }

        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('sticky', e.intersectionRatio < 1),
            {threshold: [1]}
        );

        observer.observe(stickyElm);
    }

    init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary This js determines how the table behaves in situations where there is insufficient horizontal space to display all the columns.
 * There are 3 options for the table display determined by a wrapper class.
 * 1. Row comparisons (.c-table-js--row-comparison) - means that comparing data across rows is most important for the user, and therefore the table should overflow horzontally with the row headers pinned.
 * 2. Column comparisons (.c-table-js--col-comparison) - means that comparing data between columns is most important for the user. In this scenario the table's columns and rows should switch (so the column headers become row headers and vice versa) and the table should overflow horizontally with the row headers pinned.
 * 3. Accordion (Entry data grouped) default - means that the data in each row should be consumed together onscreen at once, comparisons are not so important. In this case column headers and their data are merged into a single cell with show/hide functionality as required.
 *
*/

// Create namespace for module
var Ctable = (function () {
    'use strict';

    // Validation method
    // Check all elements that shouls be are th
    // var _spanValidation = function(tableInnards) {

    // }

    // Validation method
    // if non default table and rowspan/colspan used check not been applied to first header element
    var _spanValidation = function(tableInnards) {
        var $firstRow = tableInnards.table.find('tr').first(),
            $firstHeader = $firstRow.find('>:first-child');

        // Check that the first element is a th
        if ($firstHeader.is('th')) {
            // Check that it doesnt have a colspan/rowspan on that first element
            var checkAttrRowspan = $firstHeader.attr('rowspan');
            if (typeof checkAttrRowspan !== typeof undefined && checkAttrRowspan !== false) {
                return false;
            } else {
                var checkAttrColspan = $firstHeader.attr('colspan');
                if (typeof checkAttrColspan !== typeof undefined && checkAttrColspan !== false) {
                    return false;
                } else {
                    if ($firstHeader.parents('thead').length) {
                        $firstHeader.addClass('c-table-js-header-cell');
                        $firstHeader.siblings().addClass('c-table-js-header-cell');
                        return true;
                    } else if ($firstHeader.parents('tbody').length) {
                        $firstHeader.addClass('c-table-js-header-cell');
                        $firstHeader.parents('tbody').find('tr >:first-child').addClass('c-table-js-header-cell');
                        return true;
                    }
                }
            }
        } else {
            return false;
        }
    };

    // Add classes to table so easily targetted
    var _addBEMClasses = function(tableInnards) {
        var $thead = tableInnards.thead,
            $theaders = tableInnards.theaders,
            $trows = tableInnards.trows;

        var classRoot = 'c-table-js__';

        $thead.addClass(classRoot + 'thead');
        $theaders.addClass(classRoot + 'header-cell');
        $trows.addClass(classRoot + 'row');
        $trows.find('td').each(function() {
            $(this).addClass(classRoot + 'cell');
        });
    };

    // Define private methods here. These are not available outside this closure
    var _buildRowTable = function (tableInnards) {
        if (_spanValidation(tableInnards)) {
            // console.log('can build the row table')
            _addBEMClasses(tableInnards);
        } else {
            // console.log('can NOT build the row table!')
            return;
        }
    };

    var _buildColTable = function (tableInnards) {
        if (_spanValidation(tableInnards)) {
            // console.log('can build the col table')
            _addBEMClasses(tableInnards);
        } else {
            // console.log('can NOT build the col table!')
            return;
        }
    };

    var _buildDefaultTable = function ($tableWrap, tableInnards) {
        // Variables
        var $table = tableInnards.table,
            $thead = tableInnards.thead,
            $theaders = tableInnards.theaders,
            $trows = tableInnards.trows,
            maxrows = $tableWrap.attr('data-max-rows'),
            tableWrapper;

        // Check to see if colspans/rowspans present.
        // This table style does not work with colspans/rowspans.
        if (!tableInnards.table.find('[colspan], [rowspan]').length && $thead.length > 0) {
            // console.log('can build the default table');

            _addBEMClasses(tableInnards);

            // Wrap table
            // $table.wrap('<div class="js-table-wrapper"></div>');
            $table.wrap('<div class="c-table-js-wrapper" style="position: relative"></div>');
            $table.wrap('<div class="overflow-liner"></div>');
            tableWrapper = $table.parent();

            // Tables that exceed available width, add helper arrows
            // tableWrapper.mbieOverflowHelper();

            // Add classes

            // Mobile: Loop through each table header and copy the header to the corresponding row in the table body, to act as a more localised header. CSS then renders cells as blocks in a vertical stack.
            $trows.each(function() {
                $(this).find('td').each(function(index) {
                    var cell = $(this);
                    if (index === 0) {
                        cell.append('<button class="c-table-js__reveal"><span class="sr-only">Show/hide more</span></button>');
                    }
                    cell.before($theaders.eq(index).clone());
                });
            });

            // Mobile: Click to reveal hidden cells
            $trows.find('.c-table-js__reveal').on('click', function() {
                var row = $(this).parent().parent();
                if (row.hasClass('c-table-js__row--active')) {
                    row.removeClass('c-table-js__row--active');
                } else {
                    row.addClass('c-table-js__row--active');
                }
            });

            // // If rows exceed limit, hide them
            if (maxrows !== undefined && maxrows > 0) {
                if ($trows.length > maxrows) {
                    // Append view more button
                    tableWrapper.append('<div class="c-table-js__view-full-table"><button class="c-table-js__view-full-table-btn"><span class="c-table-js__view-full-table-type">See full table</span></button</div>');
                    // Hide additional rows
                    $trows.each(function(index, el) {
                        if (index > (maxrows - 1)) {
                            $(this).addClass('hidden-md--max');
                        }
                    });
                }

                // // Click event to view all
                tableWrapper.find('.c-table-js__view-full-table button').on('click', function() {
                    $trows.removeClass('hidden-md--max');
                    $(this).parent().hide();
                    return false;
                });
            }
        } else {
            // console.log('can NOT build the default table');
            return;
        }
    };

    var _determineTableType = function($tableWrap) {
        // Variables
        var tableInnards = {
            table: $tableWrap.find('table'),
            thead: $tableWrap.find('thead'),
            theaders: $tableWrap.find('th'),
            trows: $tableWrap.find('tbody tr')
        };

        // Determine which responsive table to display
        if ($tableWrap.hasClass('c-table-js--row-comparison')) {
            _buildRowTable(tableInnards);
        } else if ($tableWrap.hasClass('c-table-js--col-comparison')) {
            _buildColTable(tableInnards);
        } else {
            _buildDefaultTable($tableWrap, tableInnards);
        }
    };

    // Public method
    var init = function() {
        var cmsTables = $('table').not('.c-table-js');

        cmsTables.each(function() {
            $(this).wrap('<div class="c-table-js c-table-js--row-comparison tablewrap--cms"></div>');
        });

        // Apply styles to tables
        $('.c-table-js').each(function() {
            _determineTableType($(this));
            $(this).find('table').mbieOverflowHelper();
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Ctable.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

var HtriggerFormSubmit = (function () {
    'use strict';

    var showReset = function(reset) {
        if ($('[data-hasfilters]').length < 1) {
            reset.fadeOut(0);
        }
        $('input, select').change(function(e) {
            reset.fadeIn(500);
        });
    };

    // Public method
    var init = function() {
        var reset = $('input[type=reset]');

        showReset(reset);

        $('.h-triggerFormSubmit-js').on('select2:select select2:unselect', function() {
            $(this).closest('form').find('[type="submit"]').first().click();
        });

        // Clear selects when form reset button is clicked
        reset.on('click', function() {
            var selects = $('select'),
                inputs = $('fieldset input'),
                submit = $(this).closest('form').find('[type="submit"]'); // not actions

            submit.attr('disabled', true);

            if (selects.length > 0) {
                selects.val('').trigger('change');
            }

            if (inputs.length > 0) {
                inputs.val('');
            }

            if ($('[data-hasfilters]').length > 0) {
                $(this).closest('form').submit();
            }

            reset.fadeOut(500);
            submit.attr('disabled', false);
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    HtriggerFormSubmit.init();
});


/**
 * Init and extras for youtube videos
 */
$(document).ready(function() {
    'use strict';

    $('.modal-close').click(function() {
        var modal = $(this).closest('.modal');
        modal.hide();
        destroyPlayer(modal);
    });

    /**
     *
     * @param self
     */
    function handleYoutube(self, target) {
        createPlayer(self, $(target));

        if ($(self).data('modal-transcript')) {
            setTimeout(function() {
                scrollToTranscript(self);
            }, 500);
        }
    }

    /**
     *
     * @param self
     */
    function scrollToTranscript(self) {
        var targetID = $(self).data('modal-transcript'),
            target = document.getElementById(targetID);

        if (target !== null) {
            target.scrollIntoView(true);
        }
    }

    function destroyPlayer(scope) {
        $(scope)
            .find('iframe')
            .remove();
    }

    function createPlayer(self, target) {
        var autoPlay = 1,
            videoEl = target.data('video-render')
                ? target
                : target.find('[data-video-render]'),
            videoId = getYTvid($(self).data('video-url')),
            origin = location.protocol + '//' + location.hostname;

        if ($(self).data('modal-transcript') || $(self).data('embedded-video')) {
            autoPlay = 0;
        }

        videoEl.append(
            $(
                '<iframe src="https://www.youtube.com/embed/' +
                videoId +
                '?enablejsapi=1&iv_load_policy=3&origin=' +
                origin +
                '&autoplay=' +
                autoPlay +
                '&showinfo=0&rel=0" frameborder="0"></iframe>'
            )
        );
    }

    /**
     *
     * @param url
     * @returns {*}
     */
    function getYTvid(url) {
        if (/youtu\.be/.test(url)) {
            return url
                .split('youtu.be/')[1]
                .split('?')[0]
                .split('&')[0]
                .split('#')[0];
        } else if (/youtube\.com\/v\//.test(url)) {
            return url
                .split('youtube.com/v/')[1]
                .split('?')[0]
                .split('&')[0]
                .split('#')[0];
        } else if (/youtube\.com\/embed\//.test(url)) {
            return url
                .split('youtube.com/embed/')[1]
                .split('?')[0]
                .split('&')[0]
                .split('#')[0];
        } else if (
            /youtube.com|youtuberepeater.com|listenonrepeat.com/.test(url)
        ) {
            return url.split('v=')[1].split('&')[0].split('#')[0];
        } else {
            return false;
        }
    }

    $('[data-video-url]').click(function() {
        var modal = $($(this).data('target'));
        modal.show();
        handleYoutube(this, modal);
    });
});
